import React from 'react';
import { Box } from '@mui/material';
import { useStyles } from './CollapsibleContent.styles';

interface Props {
  children: React.ReactNode;
  isExpanded: boolean;
}

const CollapsibleContent = ({ children, isExpanded }: Props) => {
  const classes = useStyles();
  return (
    <Box
      className={
        isExpanded
          ? classes.CollapsibleContentOpen
          : classes.CollapsibleContentClose
      }
      data-test-id="Collapsible-content"
    >
      {children}
    </Box>
  );
};

export default CollapsibleContent;
